export default __webpack_public_path__ + "static/media/devops-admin.5f65f4a3.png";